export default "__VITE_ASSET__aiQ4p8iF__"